// src/components/Spinner.js
import React from "react";
import { useLoading } from "../context/LoadingContext";

const Spinner = () => {
  const { loading } = useLoading();

  return loading ? (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
      <div className="w-16 h-16 border-4 border-t-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
    </div>
  ) : null;
};

export default Spinner;
